module.exports = __webpack_public_path__ + "img/service2.15b347a7.png";